var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box } from "@material-ui/core";
import { FTLButton } from "../../../..";
export default (_a) => {
    var { currentTabIndex, disabled, children, primaryCustomGroup, secondaryCustomGroup, position = "sticky", onSaveMessage = "Сохранить", onCancelMessage = "Отмена", onCancel, onSave, onSaveBtnId, async, goToNextTab = () => { }, goToPrevTab = () => { }, BoxProps, showSaveButton = true, showIndexesButtons = true, direction = "left", paddingLeft = 0, paddingRight = 0 } = _a, otherProps = __rest(_a, ["currentTabIndex", "disabled", "children", "primaryCustomGroup", "secondaryCustomGroup", "position", "onSaveMessage", "onCancelMessage", "onCancel", "onSave", "onSaveBtnId", "async", "goToNextTab", "goToPrevTab", "BoxProps", "showSaveButton", "showIndexesButtons", "direction", "paddingLeft", "paddingRight"]);
    return (React.createElement(React.Fragment, null,
        position !== "static" && (React.createElement(Box, { mt: "auto", mb: 6, height: "56px", flexShrink: "0" })),
        React.createElement(Box, Object.assign({ mt: position === "static" ? 6 : undefined, display: "flex", pr: paddingRight, pl: paddingLeft, justifyContent: direction === "space-around" &&
                (onCancel || secondaryCustomGroup) &&
                (showSaveButton || primaryCustomGroup || children)
                ? "space-around"
                : "space-between", flexDirection: direction === "right" ? "row-reverse" : "row", position: position, bottom: "0", width: "inherit", height: "56px", alignItems: "center", zIndex: 1, borderTop: "2px solid #E3E5E8", flexShrink: "0", style: {
                background: "#fff",
            } }, BoxProps, otherProps),
            React.createElement(Box, { display: "flex", justifyContent: direction === "space-around" && !secondaryCustomGroup && !onCancel
                    ? "space-around"
                    : "space-between", width: direction === "space-around" &&
                    direction === "space-around" &&
                    !secondaryCustomGroup &&
                    !onCancel
                    ? "100%"
                    : "auto" },
                showSaveButton == true && (React.createElement(FTLButton, { form: onSaveBtnId, async: async, type: "submit", color: "primary", disabled: disabled, onClick: (e) => {
                        if (onSave) {
                            e.preventDefault();
                            onSave();
                        }
                    }, style: {
                        flexShrink: 0,
                    } }, onSaveMessage)),
                onCancel && (React.createElement(Box, { ml: 2, flexShrink: 0 },
                    React.createElement(FTLButton, { variant: "text", onClick: () => onCancel && onCancel() }, onCancelMessage))),
                primaryCustomGroup,
                children),
            React.createElement(Box, { display: "flex", width: direction === "space-around" &&
                    !primaryCustomGroup &&
                    !showSaveButton &&
                    !children
                    ? "100%"
                    : "auto", justifyContent: direction === "space-around" &&
                    !primaryCustomGroup &&
                    !showSaveButton &&
                    !children
                    ? "space-around"
                    : "space-between" },
                secondaryCustomGroup,
                typeof currentTabIndex === "number" && showIndexesButtons && (React.createElement(Box, { display: "flex" },
                    React.createElement(FTLButton, { color: "secondary", onClick: goToPrevTab }, "\u041D\u0430\u0437\u0430\u0434"),
                    React.createElement(Box, { ml: 2 },
                        React.createElement(FTLButton, { color: "secondary", onClick: goToNextTab }, "\u0414\u0430\u043B\u0435\u0435"))))))));
};
//# sourceMappingURL=FTLToolbar.js.map